var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ColumnBaseSelectComponent } from '../base/columnbase-select.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var CheckboxComponent = /** @class */ (function (_super) {
    __extends(CheckboxComponent, _super);
    function CheckboxComponent(service, baseService, cdRef) {
        var _this = _super.call(this, service, baseService, cdRef) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cdRef = cdRef;
        _this.vals = {};
        return _this;
    }
    CheckboxComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setValue();
    };
    CheckboxComponent.prototype.ngOnChanges = function (changes) {
        if (changes.val && !changes.val.firstChange) {
            this.setValue();
        }
        _super.prototype.ngOnChanges.call(this, changes);
    };
    CheckboxComponent.prototype.setValue = function () {
        var _this = this;
        var options = (this.col.params && this.col.params.options ? this.col.params.options : []);
        for (var i = 0; i < options.length; i++) {
            this.vals[this.colKey + '-' + options[i].code] = { value: options[i].code, checked: false };
        }
        if (this.val instanceof Array) {
            this.val = this.val.map(function (v) {
                v = v.toString();
                if (typeof _this.vals[_this.colKey + '-' + v] !== 'undefined') {
                    _this.vals[_this.colKey + '-' + v]['checked'] = true;
                }
                return v;
            });
        }
    };
    CheckboxComponent.prototype.onChange = function (e) {
        this.vals[e.target.id]['checked'] = e.target.checked;
        var v = [];
        for (var key in this.vals) {
            if (this.vals[key]['checked']) {
                v.push(this.vals[key]['value']);
            }
        }
        _super.prototype.onChange.call(this, v);
    };
    CheckboxComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-checkbox',
                    template: "<ng-template ngFor let-option [ngForOf]=\"col.params.options\" let-index=\"index\" [ngForTrackBy]=\"trackByOption\">\n  <input type=\"checkbox\" id=\"{{ colKey }}-{{ option.code }}\" name=\"{{ colKey }}\" value=\"{{ option.code }}\"\n         [checked]=\"vals[colKey + '-' + option.code].checked\" (change)=\"onChange($event)\" [key]=\"key\" [col]=\"col\" columnDir>\n  <label for=\"{{ colKey }}-{{ option.code }}\" [key]=\"key\" [col]=\"col\" columnDir>{{ option.display }}</label>\n  <br *ngIf=\"col.params?.vertical === true && index < col.params.options.length - 1\">\n</ng-template>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    CheckboxComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ChangeDetectorRef }
    ]; };
    return CheckboxComponent;
}(ColumnBaseSelectComponent));
export { CheckboxComponent };
//# sourceMappingURL=checkbox.component.js.map